import React, { useState } from "react";
import useAxiosHook from "../comn/axios.hook";
import { useParams } from "react-router-dom";

const usePartnerHook = () => {
    const params = useParams();
    //axios
    const { axiosPostHandler } = useAxiosHook();
    
    /* ==================== 아이템수정 - 가격정보호출API ==================== */
        const [ priceGroupList, setPriceGroupList ] = useState([]);
        const vehiclePriceGroupListAPI = async () => {//type - 1.등록, 2.수정
            const DATA = { "ITEM_CD": params.item };
            const result = await axiosPostHandler(`partnerItemInfoGroupListForPartner.do`, DATA)
            if (!result){return;}
            if (result.message == "SUCCESS") {
                setPriceGroupList(result.data);
            }
        }
        /* ==================== 아이템수정 - 가격정보호출API ==================== */
        
    return{
        vehiclePriceGroupListAPI, priceGroupList, setPriceGroupList// 아이템수정 - 가격정보호출API
    };
}
export default usePartnerHook;